// extracted by mini-css-extract-plugin
export default {"container":"YAxisLabel_container__5S4uK","label":"YAxisLabel_label__1fdjb"};